import { Injectable } from '@angular/core';
import { Observable, map, take } from 'rxjs';
import { ApplicationService, BaseDataDto, CountryDto, SexType } from 'swagger';
import { AppConfigService } from '@core/app-config/app-config.service';

@Injectable({
  providedIn: 'root',
})
export class BaseDataService {
  private baseData: BaseDataDto;
  private allSexTypes: SexType[] = Object.values(SexType);

  constructor(
    private applicationService: ApplicationService,
    private appConfigService: AppConfigService,
  ) {
    this.fetchData();
  }

  public fetchData(): Observable<BaseDataDto> {
    return this.applicationService.getBaseData().pipe(
      take(1),
      map((response: BaseDataDto) => {
        this.baseData = response;
        return response;
      }),
    );
  }

  getData(): BaseDataDto {
    return { ...this.baseData };
  }

  getAllCountries(): Array<CountryDto> {
    return [...this.baseData.countries];
  }

  getSexTypes(): SexType[] {
    const config = this.appConfigService.getConfig();
    const allowedSexTypes = config.allowedSexTypes;

    if (!allowedSexTypes || allowedSexTypes.length === 0) {
      return this.allSexTypes;
    }

    return this.allSexTypes.filter(sexType => allowedSexTypes.includes(sexType));
  }
}
